import angular from 'angular';
import template from './template.jade';
import './styles.styl';

export default angular
	.module('ui.cian.textarea', [])
	.directive('cianUiTextarea', ['$filter', $filter => ({
		restrict: 'E',
		scope: {},
		template,
		require: ['ngModel', 'cianUiTextarea'],
		controller: function() {
			this.maxlength = false;
			this.counter = 0;
		},
		bindToController: {
			message: '=ngModel',
			placeholderText: '@?',
      onBlur: '&?',
		},
		controllerAs: 'textarea',
		link: function(scope, element, attrs, [ngModelCtrl, cianUiTextareaCtrl]) {
			cianUiTextareaCtrl.message = cianUiTextareaCtrl.message || '';
			const getCounter = () => {
				const counter = cianUiTextareaCtrl.maxlength - cianUiTextareaCtrl.message.replace(/\r(?!\n)|\n(?!\r)/g, "\r\n").length;
				return counter > 0 ? $filter('number')(counter) : 0; // 0 для отрицательных значений
			};

			const initMaxlength = maxlength => {
				cianUiTextareaCtrl.maxlength = Number(maxlength);
				if (isNaN(cianUiTextareaCtrl.maxlength) || cianUiTextareaCtrl.maxlength <= 0) {
					cianUiTextareaCtrl.maxlength = false;
					return;
				}
				cianUiTextareaCtrl.counter = getCounter();
				element.find('textarea').attr('maxlength', cianUiTextareaCtrl.maxlength); // даем ввести на один символ больше, что бы вызвать ошибку

				ngModelCtrl.$validators.maxlength = (modelValue, viewValue) => {
					return angular.isString(modelValue) ? cianUiTextareaCtrl.maxlength >= modelValue.length : true;
				};

				ngModelCtrl.$render = () => {
					cianUiTextareaCtrl.counter = getCounter();
				};
			};

			attrs.$observe('maxlength', initMaxlength);

			cianUiTextareaCtrl.setTouched = () => {
				ngModelCtrl.$setTouched(true);
			};

      cianUiTextareaCtrl.handleBlur = () => {
        cianUiTextareaCtrl.setTouched();

        if (typeof cianUiTextareaCtrl.onBlur === "function") {
          cianUiTextareaCtrl.onBlur();
        }
      }
		}
	})])
	.name;
